import { render, staticRenderFns } from "./ResetPasswordFlow.vue?vue&type=template&id=bd076d48&scoped=true"
import script from "./ResetPasswordFlow.vue?vue&type=script&lang=js"
export * from "./ResetPasswordFlow.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordFlow.vue?vue&type=style&index=0&id=bd076d48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd076d48",
  null
  
)

export default component.exports